export async function getAvatarUrl() {
  try {
    const response = await fetch(
      "https://gateway-public.theophile-yvars.com/service-projects/v1/get/avatar-url",
      {
        headers: { "Content-Type": "application/json" },
      }
    );

    if (!response.ok) {
      throw new Error("Erreur lors de la récupération de l’URL de l’avatar");
    }

    const data = await response.json();
    return data.url; // <- l’URL presignée que MinIO renvoie
  } catch (error) {
    console.error(error);
    return null;
  }
}